module.exports = __webpack_public_path__ + "img/logo_sirka.80b07766.png";